'use client';

import React from 'react';
import { styled } from 'styled-components';
import { Text } from '../components/Text'; // long import to avoid circular deps

const StyledAvatarBackground = styled.div.withConfig({
  componentId: "aui__sc-67tkbs-0"
})(["background-color:var(--aui-primary);color:var(--aui-on-primary);flex-shrink:0;width:", ";height:", ";border-radius:var(--aui-border-radius-round);display:inline-flex;justify-content:center;align-items:center;"], ({
  $diameter
}) => $diameter, ({
  $diameter
}) => $diameter);

/**
 * Internal Avatar component with basic feature set
 */
export const Avatar = ({
  size,
  children
}) => {
  const diameter = {
    sm: '1.25rem',
    lg: '2rem'
  }[size];
  const fontSize = {
    sm: 1,
    lg: 4
  }[size];
  return /*#__PURE__*/React.createElement(StyledAvatarBackground, {
    "data-aui": "avatar",
    $diameter: diameter
  }, /*#__PURE__*/React.createElement(Text, {
    size: fontSize,
    weight: "heavy"
  }, children));
};